export default "__VITE_ASSET__DIjHEVXh__"